import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getUnpinPostFromSpaceKey, getPostKey, getPostsKey, getPinnedPostsKey, } from '../../utils/keys';
export const useUnpinPostFromSpace = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(variables => client.posts.unpinFromSpace(variables), {
        onSettled: (data, error, variables) => {
            const postKey = getPostKey(variables.postId);
            queryClient.invalidateQueries(postKey);
            const postsKey = getPostsKey();
            queryClient.invalidateQueries(postsKey);
            const pinnedPostsKey = getPinnedPostsKey();
            queryClient.invalidateQueries(pinnedPostsKey);
        },
        mutationKey: getUnpinPostFromSpaceKey(),
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUnpinPostFromSpace.js.map